import styled from 'styled-components';
import media from '~/client/shared/media';
import Stack from '~/client/shared/Stack';

const RecentGrid = styled(Stack)`
  grid-template-columns: repeat(1, 1fr);
  ${media.desktopSmall} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export default RecentGrid;
